<template>
	<div>
		<!-- 右边联系客服部分 -->
		<div class="pre_over_right pre_right_middle" v-show="show_pc"
			:class="[isshowright==true?css_right_big:css_right_small]">
			<div class="pre_right_close"><img src="@/assets/img/guanbi.png" alt="点击关闭" title="点击关闭"
					@click="fun_close_right">
			</div>
			<div class="pre_right_title">在线客服</div>
			<div class="pre_right_qq">
				<a target="_blank" :href="answer_qq">
					<img border="0" src="@/assets/img/qq.png" alt="点我咨询" title="点我咨询" /><span>点我咨询</span>
				</a>
			</div>
			<div class="pre_right_answer">
				<h4>拨打热线:</h4>
				<!-- <p>{{answer_p1}}</p> -->
				<p>{{answer_p2}}</p>
			</div>
			<div class="pre_right_erweima">
				<img border="0" src="@/assets/img/wx.jpg" /><span>手机扫一扫</span>
			</div>

		</div>

		<div class="pre_over_right pre_right_middle pre_right_middleapp" v-show="show_app"
			:class="[isshowright==true?css_right_big:css_right_small]">
			<div class="pre_right_kefu"><img class="blink" src="../../assets/img/kefu.png" /><a
					:href="'tel:'+answer_p1">客服01</a></div>
			<div class="pre_right_kefu"><img class="blink" src="../../assets/img/kefu.png" /><a
					:href="'tel:'+answer_p2">客服02</a></div>
		</div>

		<div class="pre_over_right2" v-show="show_pc" :class="[isshowright==true?css_right_small:css_right_big]">
			<div class="pre_right_title2" @click="fun_close_right">在线客服</div>
		</div>

		<!-- 底部留言板部分 -->
		<!-- <div class="pre_over_top pre_right_bottom" v-show="show_pc">
      <div class="pre_title" @click="fun_close_bottom"><span class="blink">{{pre_title}}</span><label
          :class="[isclose==true?css_small:css_big]"></label></div>
      <div class="pre_book" :class="[isclose==true?'pre_right_bottom_show':'pre_right_bottom_close']">
        <ul>
          <li class="pre_book_row">
            <textarea type="text" v-model="content" placeholder="请在此输入留言内容，我们会尽快与您联系。（必填）"></textarea>
          </li>
          <li class="pre_book_row">
            <input type="text" placeholder="姓名" v-model="username">
          </li>
          <li class="pre_book_row">
            <input type="text" placeholder="电话（必填）" v-model="phone">
          </li>
          <li class="pre_book_row">
            <input type="text" placeholder="邮箱（必填）" v-model="email">
          </li>
        </ul>
        <button :style="[default_background,ok_background]" @click="submitdata">提交提交{{pre_seconde}}</button>
      </div>
    </div> -->
		<!-- 弹窗部分 -->
		<div v-show="pre_showovertop" class="pre_more">
			<span class="pre_overtop_bg" @click="closeshow"></span>
			<div class="pre_overtop_conten">
				<span class="pre_more_close">
					<img src="../../assets/img/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="agent" v-show="show_pc">
						<h1 class="ag-bt1">信息提交</h1>
						<ul class="ag">
							<li class="ag-button">
								<p class="ag-wz">真实姓名：<span>*</span></p>
								<input type="text" placeholder="请输入您的真实姓名" v-model="username">
							</li>
							<li class="ag-button">
								<p class="ag-wz">联系手机：<span>*</span></p>
								<input type="text" placeholder="请输入您的联系方式" v-model="phone">
							</li>
							<li class="ag-button">
								<p class="ag-wz">详细信息描述 <span>*</span></p>
								<textarea name="" id="" cols="30" rows="10" v-model="data"></textarea>
							</li>

						</ul>
						<input type="button" value="提交" class="tj" @click="submitdata">
					</div>
					<div id="pre_msg_data"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*
名称：弹窗组件_浮动加盟
日期：2020-06-29
作者：hj
目标:
1、弹出收缩
2、默认一闪一闪
3、留言功能 留言信息上传到服务器。后台可以查看，并且删除。：



*/
	import myhttp from '@/utils/type.js'
	import {
		sysSelect
	} from '@/utils/systemSelect.js';
	import {
		ChangeSpecial
	} from '@/utils/localstore.js';
	import {
		base_encode
	} from '@/utils/base64.js';
	import {
		checkStringByForm
	} from '@/utils/method';

	import {
		Method_EasyAdd
	} from '@/utils/loadhttpdata.js';

	export default {
		/*组件名称不能和系统关键字重复*/
		name: "pre_overtop",
		data() {
			return {
				ok_background: this.GLOBAL.ok_sel_background,
				default_background: this.GLOBAL.def_sel_background,
				btn_ifuse: '1',
				pre_seconde: '',

				pre_showovertop: false,
				pre_showtype: 'jm',
				pre_showstyle: 'pre_over_top pre_right_bottom',
				pre_title: '我是悬浮框名称',

				answer_qq: 'http://wpa.qq.com/msgrd?v=3&uin=1215739819&site=qq&menu=yes',
				answer_p1: '13891961908(微信同号)',
				answer_p2: '18092018522(微信同号)',

				/*最大化最小化切换*/
				isclose: true,
				css_small: 'iconfont icon-visible pre_book_icon',
				css_big: 'iconfont icon-fangkuang pre_book_icon',

				/*右边显示缩小*/
				isshowright: false,
				css_right_small: 'pre_right_small',
				css_right_big: 'pre_right_big',


				content: '',
				username: '',
				phone: '',
				data: '',
				email: '',
				show_pc: false,
				show_app: false
			}
		},
		props: {
			// 展示类型
			showtype: {
				type: String,
				default: ''
			},
			// 展示内容
			showtitle: {
				type: String,
				default: ''
			}
		},
		created: function() {
			this.showCard();

			this.sys_type = sysSelect();
			if (this.sys_type == 'PC') {
				this.show_pc = true;
				this.show_app = false;
			} else if (this.sys_type == 'YD') {
				this.show_pc = false;
				this.show_app = true;
			} else {
				this.show_pc = true;
				this.show_app = false;
			}


			// this.loaddata();
		},
		methods: {
			showCard: function() {
				// window.location.hash = "#mytop";
				// $('html,body').animate({scrollTop: '540px'}, 500);
				if (this.showtype == 'jm') {
					this.pre_showtype = 'jm';
					this.pre_showstyle = 'pre_over_top pre_right_bottom';
					this.pre_title = '联系我们';
				} else {
					this.pre_title = '传参错误';
				}
			},
			showovertop: function() {
				this.pre_showovertop = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pre_overtop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pre_overtop_bg").fadeIn("3000");
				$(".pre_overtop_conten").fadeIn("3000");
			},
			change_show: function() {
				console.log('状态改变 == ' + this.pre_showovertop);
				if (this.pre_showovertop) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_overtop_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_overtop_bg").fadeIn("3000");
					$(".pre_overtop_conten").fadeIn("3000");
					this.re_load = false;
				} else {
					$(".pre_overtop_bg").fadeOut("3000");
					$(".pre_overtop_conten").fadeOut("3000");
				}
			},
			closeshow: function() {
				$(".pre_overtop_bg").fadeOut("3000");
				$(".pre_overtop_conten").fadeOut("3000");
				// this.show_fileup=false;
			},
			fun_close_right: function() {

				this.isshowright = this.isshowright == true ? false : true;
			},
			fun_close_bottom: function() {
				console.log('关闭右边');
				this.isclose = this.isclose == true ? false : true;
			},
			loaddata: function() {
				// console.log(mystore.getParm('city'));

			},
			submitdata: function() {
				if (this.btn_ifuse != '1') {
					this.$message({
						message: ' 您好,刚发布完留言,请稍等下再次发布!',
						type: 'warning'
					});
					return;
				}

				console.log(this.username);
				console.log(this.phone);
				console.log(this.email);
				console.log(this.content);

				if (String(this.phone).trim().length == 0) {
					this.$message({
						message: ' 电话号码必须填写',
						type: 'warning'
					});
					return;
				}

				if (!checkStringByForm(this.phone, 'phone')) {
					this.$message({
						message: this.phone + ' 不是有效的电话号码',
						type: 'warning'
					});
					return;
				}

				if (!checkStringByForm(this.email, 'email')) {
					this.$message({
						message: this.email + ' 不是有效的邮箱',
						type: 'warning'
					});
					return;
				}

				this.$post(
					myhttp.http_method,
					Method_EasyAdd('data_message', this.username, this.phone, this.email, ChangeSpecial(this
						.content))
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data);
					res = res;
					this.btn_ifuse = '0';
					if (Number.parseInt(res.data.status) == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.msg,
							type: 'error'
						});
					}

					var that = this;
					var num = 61;
					var temp_time = setInterval(function() {
						num = num - 1;
						// console.log('t='+num);
						that.pre_seconde = '(' + num + '秒)';
						if (num <= 0) {
							clearInterval(temp_time);
							that.pre_seconde = '';
							that.btn_ifuse = '1';
						}
					}, 1000);



				});

			}
		}
	};
</script>

<style scoped>
	/* 右边中间 */
	.pre_over_right {
		width: 180px;
		height: auto;
		overflow: hidden;
		position: fixed;
		background-color: #0000ff;
		border-radius: 150px;
		text-align: center;
		color: #FFF;
		z-index: 999999;
	}

	.pre_right_middle {
		/* right: 0px; */
		bottom: 280px;
	}

	.pre_over_right2 {
		width: 25px;
		height: 100px;
		overflow: hidden;
		position: fixed;
		background-color: #0000ff;
		border-radius: 50px;
		text-align: center;
		color: #FFF;
		z-index: 999999;
		bottom: 380px;
	}

	.pre_right_close {
		width: 16px;
		height: 16px;
		margin: 0 auto;
		margin-top: 10px;
		cursor: pointer
	}

	.pre_right_close>span {
		height: 100%;
		width: auto;
	}

	.pre_right_title {
		height: 50px;
		font-size: 20px;
		line-height: 50px;
	}

	.pre_right_title2 {
		height: 100%;
		font-size: 16px;
		line-height: 20px;
		margin-top: 10px;
		cursor: pointer;

	}

	.pre_right_qq {
		border-bottom: 1.5px solid rgba(255, 255, 255, 1);
		border-top: 1.5px solid rgba(255, 255, 255, 1);
		height: auto;
		overflow: hidden;
		padding-top: 8px;
		padding-bottom: 8px;
	}

	.pre_right_qq>a {
		color: white;
	}

	.pre_right_qq>a>img {
		display: inline-block;
		vertical-align: middle;
		width: 28px;
		height: auto;
	}

	.pre_right_qq>a>span {
		display: inline-block;
		vertical-align: middle;
		width: 80px;
		height: auto;
	}

	.pre_right_answer {
		height: auto;
		overflow: hidden;
		padding-top: 10px;
		padding-bottom: 10px;

		text-align: center;
		display: inline-flex;
		flex-direction: column;
		align-items: center;

	}

	.pre_right_answer>h4 {
		font-size: 12px;
		color: white;
	}

	.pre_right_answer>p {
		font-size: 12px;
		color: white;
		padding: 0px;
	}

	.pre_right_erweima {
		padding-bottom: 8px;
		padding-top: 10px;
		text-align: center;
	}

	.pre_right_erweima>img {
		width: 100px;
		height: auto;
	}

	.pre_right_erweima>span {
		display: block;
	}

	.pre_right_small {
		right: -180px;
		animation: rightsmall 0.6s;
		-webkit-animation: rightsmall 0.6s;
		/* Safari and Chrome */
	}



	.pre_right_big {
		right: 0px;
		animation: rightbig 0.6s;
		-webkit-animation: rightbig 0.6s;
		/* Safari and Chrome */
		padding: 6px;
	}

	@keyframes rightsmall {
		from {
			right: 0px;
		}

		to {
			right: -180px;
		}
	}

	@-webkit-keyframes rightsmall

	/* Safari and Chrome */
		{
		from {
			right: 0px;
		}

		to {
			right: -180px;
		}
	}

	@keyframes rightbig {
		from {
			right: -180px;
		}

		to {
			right: 0px;
		}
	}

	@-webkit-keyframes rightbig

	/* Safari and Chrome */
		{
		from {
			right: -180px;
		}

		to {
			right: 0px;
		}
	}

	.pre_right_middleapp {
		margin-bottom: 0px;
		width: 100px;
		padding: 3px;
	}

	.pre_right_kefu>img {
		display: inline-block;
		width: 24px;
		height: auto;

	}

	.pre_right_kefu>a {
		display: inline-block;
		color: white;
		margin-left: 2px;
		margin-top: -5px;
	}

	/*右下角*/
	.pre_over_top {
		background-color: #ededed;
		overflow: hidden;
		z-index: 999999;
		position: fixed;
		/* right: 10px;
    bottom: 150px; */
		padding: 0px;
		text-align: center;
		width: 240px;
		/* height: 270px; */
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	.pre_right_bottom {
		right: 0px;
		bottom: 0px;

	}

	.pre_title {
		cursor: pointer;
		background-color: #0000FF;
		text-align: left;
		line-height: 24px;

	}

	.pre_right_bottom_show {
		/* height: 240px; */
		animation: bottomshow 0.6s;
		-webkit-animation: bottomshow 0.6s;
		/* Safari and Chrome */
	}

	.pre_right_bottom_close {
		height: 0px;
		animation: bottomclose 0.6s;
		-webkit-animation: bottomclose 0.6s;
		/* Safari and Chrome */
	}

	@keyframes bottomshow {
		from {
			height: 0px;
		}

		to {
			height: 240px;
		}
	}

	@-webkit-keyframes bottomshow

	/* Safari and Chrome */
		{
		from {
			height: 0px;
		}

		to {
			height: 240px;
		}
	}

	@keyframes bottomclose {
		from {
			height: 240px;
		}

		to {
			height: 0px;
		}
	}

	@-webkit-keyframes bottomclose

	/* Safari and Chrome */
		{
		from {
			height: 240px;
		}

		to {
			height: 0px;
		}
	}

	/* 闪烁 */
	/* 定义keyframe动画，命名为blink */
	@keyframes blink {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	/* 添加兼容性前缀 */
	@-webkit-keyframes blink {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@-moz-keyframes blink {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@-ms-keyframes blink {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@-o-keyframes blink {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	/* 定义blink类*/
	.blink {
		color: #ffffff;
		animation: blink 1s linear infinite;
		/* 其它浏览器兼容性前缀 */
		-webkit-animation: blink 1s linear infinite;
		-moz-animation: blink 1s linear infinite;
		-ms-animation: blink 1s linear infinite;
		-o-animation: blink 1s linear infinite;
		font-size: 10px;
		font-weight: bold;
		margin-left: 10px;
	}

	.blink:hover {
		cursor: pointer;
	}


	/*留言板*/
	.pre_book_icon {
		color: white;
		position: relative;
		display: inline-block;
		vertical-align: middle;
		margin-left: 160px;
		cursor: pointer;

	}

	.pre_book {
		width: 100%;
		padding: 5px;
		overflow: hidden;
		text-align: center;
	}

	.pre_book>button {
		width: 40%;
		margin-left: -11px;
		border-color: #0000FF;
		background-color: #0000FF;
		color: #FFFFFF;
	}

	.pre_book>button:hover {
		border-color: #0f63ff;
		background-color: #0f63ff;
	}

	.pre_book_row {
		text-align: center;
		margin-bottom: 1px;
		width: 94%;
		/* margin-left: -5px; */
	}

	.pre_book_row>textarea {
		width: 100%;
		border-radius: 3px;
		height: 120px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.pre_book_row input {
		width: 100%;
	}



	/* 弹窗 */
	.pre_overtop_bg {
		width: 100%;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 1340px;
		display: none;
		z-index: 99;
	}

	.pre_more {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.pre_overtop_conten {
		width: 60%;
		height: auto;
		margin: 0 auto;
		background: #faf5f5;
		position: fixed;
		top: 15%;
		border-radius: 3px;
		display: none;
		z-index: 999;
		/* left: 40%; */
		left: 20%;
		/* text-align: center; */
	}

	.pre_more_close {
		position: absolute !important;
		right: -8px !important;
		top: -6px !important;
		font-size: 30px !important;
		color: #b4b4b4;
		cursor: pointer;
		font-weight: normal;
	}

	.pre_overtop_conten>div {
		/* margin-top: 15px; */
		width: 100%;
		text-align: center;
		padding-left: 5px;
		padding-right: 5px;
	}



	/*关于我们*/
	.agent {
		width: 100%;
		padding: 5px;
		overflow: hidden;
	}

	.agent .ag-bt1 {
		color: #0c0c0b;
		font-size: 28px;
		text-align: center;
	}

	.agent .ag-bt2 {
		color: #131003;
		font-size: 16px;
		width: 80px;
		margin: 0 auto;
		text-align: center;
		padding-bottom: 10px;
		border-bottom: 4px solid #f8c80e;
	}

	.agent .ag {
		max-width: 1200px;
		margin: 50px auto 0;
		list-style-type: none;
		overflow: hidden;
	}

	.agent .ag>.ag-button {
		float: left;
		margin-bottom: 40px;
	}

	.agent .ag>.ag-button:nth-child(2n+1) {
		margin-right: 112px;
	}

	.agent .ag>.ag-button .ag-wz {
		font-weight: bold;
		width: 20%;
		min-width: 160px;
	}

	.agent .ag>.ag-button .ag-wz span {
		color: #f8c80e;
		margin-left: 60px;
	}

	.agent .ag>.ag-button>input {
		width: auto;
		min-width: 180px;
		height: 48px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.agent .ag>.ag-button>select {
		/* width:60%; */
		min-width: 180px;
		height: 48px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
		outline-style: none;
	}

	.agent .ag>.ag-button>textarea {
		width: 60%;
		min-width: 640px;
		height: 120px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
		outline-style: none;
	}

	.agent>input {
		width: 60%;
		min-width: 240px;
		height: 54px;
		border-radius: 12px;
		background: #a3a29d;
		color: #0a0303;
		font-size: 28px;
		border: none;
		margin-top: 10px;
		margin-bottom: 10px;

	}

	.agent>input:hover {
		background: #80c472;
		cursor: pointer;
	}

	.agent-app {
		width: 100%;
		margin: 80px 10px 0 10px;
	}

	.agent-app .ag-bt1 {
		color: #f8c80e;
		font-size: 28px;
		text-align: center;
	}

	.agent-app .ag-bt2 {
		color: #f8c80e;
		font-size: 16px;
		width: 80px;
		margin: 0 auto;
		text-align: center;
		padding-bottom: 10px;
		border-bottom: 4px solid #f8c80e;
	}

	.agent-app .ag {
		max-width: 100%;
		margin: 50px auto 0;
		list-style-type: none;
		overflow: hidden;
	}

	.agent-app .ag>.ag-button {
		float: left;
		margin-bottom: 15px;
	}

	.agent-app .ag>.ag-button:nth-child(2n+1) {
		margin-right: 112px;
	}

	.agent-app .ag>.ag-button .ag-wz {
		font-weight: bold;
		width: 200px;
	}

	.agent-app .ag>.ag-button .ag-wz span {
		color: #f8c80e;
		margin-left: 60px;
	}

	.agent-app .ag>.ag-button>input {
		width: 350px;
		height: 48px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.agent-app .ag>.ag-button>select {
		width: 350px;
		height: 48px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
		outline-style: none;
	}

	.agent-app .ag>.ag-button>textarea {
		width: 350px;
		height: 120px;
		border-radius: 6px;
		border: none;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding-left: 10px;
		box-sizing: border-box;
		outline-style: none;
	}

	.agent-app .ag>input {
		width: 60%;
		height: 48px;
		border-radius: 12px;
		background: #f8c80e;
		color: #ffffff;
		font-size: 28px;
		border: none;
		margin-top: 20px;
		float: left;
		cursor: pointer;
	}

	.agent-app .ag>input:hover {
		background: #010a2b;
	}

	.agent-app .mar11 {
		width: 100%;
		height: 60px;
	}
</style>
